<template>
	<div id="joinContainer">
		<!-- banner -->
		<div class="joinUs">
			<p>加入我们 共同成长</p>
			<span>我们提供广阔的成长空间, 丰厚的福利待遇, 等你来创造新零售领域未来</span>
		</div>
		<!-- item-work -->
		<div class="work">
			<div class="g_item-title">
				<div class="g_item-t_head">我们的工作氛围</div>
				<div class="g_item-t_info">在八号地大家庭，拥有一流的专业团队，工作上大家充满激情，一起努力，携手共创美好未来。</div>
			</div>
			<div class="card-wrap">
				<div class="item-card item-card-first">
					<img class="img-01" src="../assets/people/激情.png" alt />
					<p>激情</p>
				</div>
				<div class="item-card item-card-second" >
					<img class="img-02" src="../assets/people/协作.png" alt />
					<p>协作</p>
				</div>
				<div class="item-card item-card-third" >
					<img class="img-03" src="../assets/people/高效.png" alt />
					<p>高效</p>
				</div>
				<div class="item-card item-card-last" >
					<img class="img-04"  src="../assets/people/创新.png" alt />
					<p>创新</p>
				</div>
			</div>
		</div>
		<!-- item-environmental -->
		<div class="environmental">
			<div class="g_item-title">
				<div class="g_item-t_head">我们的工作环境</div>
				<div class="g_item-t_info">在八号地，有舒适的办公环境，有丰富的下午茶零食，有精彩的团建活动来等你</div>
			</div>
			<div class="swiper">
				<!-- <img src="../assets/about/BF5814C7-A5D5-4773-8330-495771114DF2@2x.png" alt=""> -->
				<swiper :options="swiperOption">
				　 <swiper-slide class="my-swiper-slide"><img src="../assets/people/2.png" alt=""></swiper-slide>
				　　<swiper-slide class="my-swiper-slide"><img src="../assets/people/3.png" alt=""></swiper-slide>
				   <swiper-slide class="my-swiper-slide"><img src="../assets/people/1.png" alt=""></swiper-slide>
				<!-- 　　<div class="swiper-pagination" slot="pagination"></div> -->
				　　<!-- <div class="swiper-button-prev" slot="button-prev"></div>
				　　<div class="swiper-button-next" slot="button-next"></div> -->
				</swiper>
			</div>

		</div>

		<!-- people -->
		<div class="people">
			<div class="g_item-title nothingInfo-header">
				<div class="g_item-t_head">我们寻找这样的人</div>
			</div>
			<div class="people-conent">
				<div class="p-conent-img">
					<img src="../assets/2x.png" alt />
				</div>
				<div class="p-conent-text">
					<div class="g_item-title nothingInfo-header">
						<div class="g_item-t_head" style="text-align: left;">如果你</div>
					</div>
					<div class="p-text-p">有梦想，勇于行动 </div>
					<div class="p-text-p">有才能，期待发挥</div>
					<div class="p-text-p">有态度，脚踏实地</div>
					<div class="p-text-p">我们给你提供发挥自我价值的平台</div>
					<div class="p-text-p">在新零售领域收获成长</div>
				</div>
			</div>
		</div>
		<!-- join -->
		<div class="join">
			<div class="g_item-title nothingInfo-header">
				<div class="g_item-t_head">我们期待您的加入</div>
			</div>
			<div class="join-cont first-join-cont">
				<div class="join-head">
					<div class="join-head-post">
						<div class="post-name"><div class="or-line"></div> 前端开发工程师</div>
						<!-- <div class="post-money">10-15K</div> -->
					</div>
					<div class="join-head-adr"> <span style="margin-left:-5px;margin-right:5px" class="el-icon-location-outline"></span>北京-丰台区-丰台科技园丰台科技园</div>
				</div>
				<div class="work-item">
					<div class="work-name">岗位职责</div>
					<div class="work-text">负责Web/App产品的页面原型实现；</div>
					<div class="work-text">负责Web/App产品的性能、用户体验优化；</div>
					<div class="work-text">负责创新产品的开发与改进，致力于通过技术改善用户体验。</div>
				</div>
				<div class="work-item">
					<div class="work-name">任职要求</div>
					<div class="work-text">计算机、软件工程、数字媒体技术相关专业优先,本科以上学历;</div>
					<div class="work-text">良好的UI Sense与审美能力,细节控,喜欢折腾的性格。</div>


				</div>
				<div class="work-item-tips">有意者请投递8haodi@8haodi.com</div>


			</div>
			<div class="join-cont">
				<div class="join-head">
					<div class="join-head-post">
						<div class="post-name"><div class="or-line"></div>Java开发工程师</div>
						<!-- <div class="post-money">10-15K</div> -->
					</div>
					<div class="join-head-adr"> <span style="margin-left:-5px;margin-right:5px" class="el-icon-location-outline"></span>北京-丰台区-丰台科技园丰台科技园</div>
				</div>
				<div class="work-item">
					<div class="work-name">岗位职责</div>
					<div class="work-text">撰写相关接口文档；</div>
					<div class="work-text">解决开发过程中的一些技术问题；</div>
					<div class="work-text">开发迭代现有电商与跟进销存管理系统。</div>
				</div>
				<div class="work-item">
					<div class="work-name">任职要求</div>
					<div class="work-text">有扎实的Java基础,Java多线程、熟练使用Java8;</div>
					<div class="work-text">熟悉主流开源应用框架,如Spring,SpringMvc等开发技术;</div>
					<div class="work-text">熟悉MySQL数据库,能对MySQL进行简单调优。</div>
				</div>
				<div class="work-item-tips">有意者请投递8haodi@8haodi.com</div>
				<div class="work-item-tips-more"><a href="https://www.zhipin.com/gongsir/75871098f92567071n1_0ty6.html?ka=company-jobs">更多职位请在boss直聘上搜索八号地查看 > </a></div>
			</div>
		</div>
		<!-- 底部表单 -->
		<div class="input_container">
			<div class="header_container">
				<p>加入我们 共同成长</p>
			</div>
			<div class="vant_container">
			  <el-form :model="JoinForm" :rules="Join_Rules" ref="JoinForm"  class="demo-ruleForm">
			    <el-form-item label="" prop="fName">
					<div class="label-join"><span>*</span>姓名:</div>
			      <el-input v-model="JoinForm.fName" placeholder="请输入您的姓名"></el-input>
			    </el-form-item>
			    <el-form-item label="" prop="fPhone">
					<div  class="label-join"><span>*</span>联系电话:</div>
			      <el-input v-model="JoinForm.fPhone" placeholder="请输入您的联系方式"></el-input>
			    </el-form-item>
			    <el-form-item  prop="city">
				  <div  class="label-join">请选择城市:</div>
			      <div class="el-select-join">
					  <el-select v-model="JoinForm.fCity" placeholder="请选择城市">
					    <el-option label="北京" value="北京"></el-option>
					  </el-select>
				  </div>
			    </el-form-item>
			    <el-form-item label="" prop="post" style="width: 100%;">
					<div  class="label-join">申请岗位:</div>
			      <el-input v-model="JoinForm.fPost" placeholder="请输入您要申请的岗位"></el-input>
			    </el-form-item>
			    <el-form-item label="" prop="personal_profile">
					<div  class="label-join">个人简介:</div>
			      <el-input type="textarea" v-model="JoinForm.text" placeholder="请输入您的个人简介"></el-input>
			    </el-form-item>
			    <el-form-item class="btns">
			      <el-button type="warning" @click="getemailinfo" size="medium" class="mobile-btn">立即申请</el-button>
			    </el-form-item>
			  </el-form>
			</div>

			<div class="news-info">申请岗位后，HR会与您电话联系</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
	import { Toast } from 'vant';
	import { Message } from "element-ui";

	export default {
		created() {
			this.$nextTick(() => {
			  document.body.scrollTop = 0
			  document.documentElement.scrollTop = 0
			})
		},
		data() {
			//   自定义验证规则
			var Name = (rule, value, callback) => {
			  const regNmae = /^[\u4e00-\u9fa5]{2,12}$/;
			  if (regNmae.test(value)) {
			    return callback();
			  } else {
			    callback(new Error("请输入正确的姓名!"));
			  }
			};
      var Post = (rule, value, callback) => {
        const regNmae = /^[\u4e00-\u9fa5]$/;
        if (regNmae.test(value)) {
          return callback();
        } else {
          callback(new Error("请选择正确的申请选项!"));
        }
      };
			var checkMobil = (rule, value, callback) => {
			  // 验证手机号的正则表达式
			  const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
			  if (regMobile.test(value)) {
			    return callback();
			  } else {
			    callback(new Error("请输正确的手机号!"));
			  }
			};
			return {
				JoinForm: {
				  fCity: "", //城市选择
				  fName: "", // 姓名
				  fPost: "", // 岗位选择
				  fPhone: "", //电话
				  text: "", //个人简介
				  fType: 0
				},
				Join_Rules: {
				  // 姓名验证
				  fName: [{
				      required: true,
				      message: "请输入您的姓名",
				      trigger: "blur"
				    },
				    {
				      validator: Name,
				      trigger: "blur"
				    }
				  ],
				  // 用户密码验证
				  fPhone: [{
				      required: true,
				      message: "请输入您的手机号",
				      trigger: "blur"
				    },
				    {
				      validator: checkMobil,
				      trigger: "blur"
				    }
				  ],
          // 申请选项验证
          fPost: [{
            required: true,
            message: "请输入您的申请选项",
            trigger: ["blur", 'change']
          }, ]
				},

				radio:'',
				Name: '',
				phone: '',
				options: false,
        loading_page:false,
				options_val:'',
				message: '',
				city:false,
				city_val:'',
				opData: [{
						name: '选项1'
					},
					{
						name: '选项2'
					}
				],
				// swiper
				swiperOption: {
					slidesPerView: 1.2,
					centeredSlides: true,
					// spaceBetween: 10,
				　　pagination: {
				　　　　el: '.swiper-pagination',
				　　　　clickable: true // 允许点击小圆点跳转
				　　},
				　　autoplay: {
				　　　　delay: 3000,
				　　　　disableOnInteraction: false // 手动切换之后继续自动轮播
				　　},
				　　loop: true,
					autoplay:true,
				　　navigation: {
				　　　　nextEl: '.swiper-button-next',
				　　　　prevEl: '.swiper-button-prev'
				　　},
					effect: 'coverflow',
					grabCursor: true,
					coverflowEffect: {
						rotate: 50,
						stretch: 0,
						depth: 100,
						modifier: 1,
						slideShadows: true,
				      },
				},

			};
		},
    // mounted (){
    //     this.$router.afterEach((to, from, next) => {
    //         window.scrollTo(0, 0)
    //         document.documentElement.scrollTop = 0
    //     })
    // },
		methods: {
			getemailinfo() {
			  let {
			    fName,
			    fPhone,
			    fCity,
			    fPost,
			    text,
			    fType,
			    filePath
			  } = this.JoinForm;
			  // 前端验证
			  this.$refs.JoinForm.validate(async valid => {
			    if (!valid) {
			      // Message.error("请检查您的信息准确性!");
				  Toast.fail('请检查您的信息准确性');
			    } else {
			      const loading = this.$loading({
			        lock: true,
			        text: "正在提交申请,请耐心等待",
			        spinner: "el-icon-loading",
			        background: "rgba(0, 0, 0, 0.7)"
			      });
			      let result = await this.$HTTP.getEmaiInfo({
			        fName,
			        fPhone,
			        fCity,
			        fPost,
			        text,
			        fType,
			        filePath
			      });
            setTimeout(() => {
              loading.close();
            }, 2000);
			      if (result.status === 200) {
			        loading.close();
			        Toast.success("提交成功!");
			        this.$refs.JoinForm.resetFields()
			        this.JoinForm.fCity = ''
			        this.JoinForm.text = ''
			        this.JoinForm.fPost = ''
			      } else {
			        // Message.error("网络开小差了~");
              Toast.fail('网络开小差了~');
              loading.close();
			      }


			    }

			  });
			},
			validator(val) {
				return /1\d{10}/.test(val);
			},
			// 异步校验函数返回 Promise
			NmaeValidator(val) {
				return new Promise(resolve => {
					Toast.loading("验证中...");

					setTimeout(() => {
						Toast.clear();
						resolve(/\d{6}/.test(val));
					}, 1000);
				});
			},
			onFailed(errorInfo) {
				console.log("failed", errorInfo);
			}
		}
	};
</script>

<style lang="stylus" scoped>
	@import '../common/stylus/mixins.styl';

	#joinContainer {
		width: 100%;
		height: 100%;

		.joinUs {
			width: 100%;
			height: 420px;
			bg-image('../assets/join-banner');
			background-size: 100% 420px;
			padding-top: 180px;
			box-sizing: border-box;
			text-align: center;

			p {
				font-size: 40px;
				font-family: Source Han Sans SC;
				font-weight: bold;
				color: rgba(255, 255, 255, 1);
				margin-bottom: 30px;
			}

			span {
				display inline-block;
				width 95%;
				margin 0 auto;
				box-sizing: border-box;
				font-size: 20px;
				line-height 36px;
				font-family: Source Han Sans SC;
				color: rgba(255, 255, 255, 1);
			}
		}

	}
	// 工作氛围
	.work{
		width 100%;
		min-height 400px;
		padding 80px 0px 10px;
		box-sizing border-box;
	}
	// 共用头部
	.g_item-title{
		width :100%;
		margin 0 auto;
		min-height 130px;
		height auto;
		text-align center;
		margin-bottom 20px;
	}
	.nothingInfo-header{
		min-height 60px;
	}
	.g_item-t_head{
		height:35px;
		font-size:36px;
		font-family:Microsoft YaHei;
		font-weight:bold;
		color:rgba(35,35,35,1);
		line-height:35px;
		margin-bottom 20px;

	}
	.g_item-t_info{
		width 90%;
		margin  0 auto;
		height :auto;
		font-size:20px;
		font-family:Microsoft YaHei;
		font-weight:400;
		color:rgba(96,96,96,1);
		line-height 30px;
	}
	.card-wrap{
		width 100%;
		height auto;
		padding-bottom 20px;
		overflow hidden;
		display flex
	}
	.item-card-first{
		margin 10px 10px 10px 0px !important;
		background-image url(../assets/people/jq.png)
		background-size 100% 100%
	}
	.item-card-second{
		background-image url(../assets/people/xz.png)
		background-size 100% 100%
	}
	.item-card-third{
		background-image url(../assets/people/gx.png)
		background-size 100% 100%
	}
	.item-card-last{
		margin 10px 0px 10px 10px !important;
		background-image url(../assets/people/cx.png)
		background-size 100% 100%
	}
	.item-card{
		padding-top 40px;
		width:25%;
		float:left;
		margin 10px;
		height 235px;
		text-align center;
		// background rgba(255,173,96,.7)
		color #fff;
	}
	.item-card img{

		margin-bottom 50px;
	}
	.img-01{
		width: 62px;
		height: 75px;
	}
	.img-02{
		width: 75px;
		height: 75px;
	}
	.img-03{
		width: 74px;
		height: 74px;
	}
	.img-04{
		width: 67px;
		height: 72px;
	}


	// swiper
	.swiper{
		width :100%;
		margin 0 auto;
		min-height 400px;
		max-height 500px;
		margin-bottom 50px;
	}
	.my-swiper-slide,.my-swiper-slide img{
		min-height 400px;
	}
	.swiper img{
		width :100%;
		height auto;
	}
	.people{
		margin-bottom 50px;
	}
	// people
	.people-conent{
		width 100%;
		min-height 514px;
		background-color: rgba(255, 243, 231, 1);
		overflow hidden;
	}
	.p-conent-img{
		box-sizing border-box;
		width :50%;
		float left;
		min-height 514px;
		height auto
		padding 50px 0px;
	}
	.p-conent-img>img {
	  width: 320px;
	  height: 400px;

	}
	.p-conent-text{
		padding-top 130px;
		margin-left 50%;
		min-height 514px;
		height auto
	}
	.p-text-p{
		height:auto;
		font-size:18px;
		font-family:Microsoft YaHei;
		font-weight:400;
		color:rgba(96,96,96,1);
		line-height:40px;
	}


	// join
	.join{
		margin-bottom 30px;
	}
	.join-cont{
		width 100%;
		margin 0 auto;
		min-height 414px;
		margin-bottom 50px;
	}
	.first-join-cont{
		padding-bottom 30px;
		border-bottom 1px solid #EDEDED;
	}
	.join-head{
		width 80%;
		margin 0 auto;
		height auto;
		margin-bottom 20px;

	}
	.join-head-post{
		overflow hidden;
		height 50px;
		line-height 50px;
	}
	.post-name{
		float left;
		font-size:28px;
		font-weight:bold;
		font-family:Microsoft YaHei;
		// padding-left 10px;

	}
	.post-money{
		margin-left 80%;
		text-align center;
	}
	.join-head-adr{
		line-height 36px;
		// padding-left 20px;
	}
	.work-item{
		width:80%;
		margin 0 auto;
		padding-top 20px;
		margin-bottom 20px;
	}
	.work-item-tips{
		width:80%;
		margin 0 auto;
		height:24px;
		font-size:24px;
		font-family:Microsoft YaHei;
		font-weight:bold;
		color:rgba(255,173,96,1);
		line-height:30px;
		margin-bottom 20px;
	}
	.work-item-tips-more a{
		font-weight:bold;
		color:rgba(35,35,35,1);
	}
	.work-item-tips-more{
		width:80%;
		margin 0 auto;
		height:24px;
		font-size:24px;
		font-family:Microsoft YaHei;

	}
	.or-line{
		width:3px;
		height 30px;
		background #FFAD5F;
		float left;
		margin-top 8px;
		margin-right 20px;
	}
	.work-name{
		margin-bottom 20px;
		font-size 24px !important;
		font-weight:bold;
		font-family:Microsoft YaHei;
	}
	.work-text{
		line-height 36px;
		color #606060;
	}
	// 底部
	.input_container {
		width: 100%;
		height: auto;
		padding-bottom 30px;
		overflow: hidden;
		bg-image('../assets/message');
		background-size: 100% 1012px;
		background-repeat: no-repeat;
		.header_container {
			width: 100%;
			height: 136px;
			position: relative;
			text-align center;

			>p {
				width: 100%;
				font-size: 36px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: rgba(255, 255, 255, 1);
				position: absolute;
				bottom: 0;
			}
		}

		.interval {
			width: 100%;
			height: 47px;
		}

		.vant_container {
			padding: 0 80px;
			box-sizing: border-box;
		}
	}

	.jiange1 {
		width: 100%;
		height: 44px;
	}

	.input-label {
		color #fff;
		margin-bottom: 10px;
	}

	.input-label span {
		color: #FA3A43;
		margin-right: 10px;
	}
	.news-info {
		padding-top 20px;
		width:100%;
		margin 0 auto;
		text-align center;
		height:auto;
		line-height 40px;
		font-size:20px;
		font-family:Microsoft YaHei;
		font-weight:400;
		color:rgba(255,255,255,1);
	}
	.btns{
    width 100%;
		padding-top 10px;
		margin 0 auto;
		text-align center
	}
	.el-select-join{
		width 100%
	}
	.label-join{
		width 100%
		height 50px
		color #fff
	}
	.label-join span{
		color red
		margin-right 10px
	}
  .mobile-btn{
    width :100%;
    height 48px;
  }
</style>
<style>
	.el-input__inner{
		width: 590px;
		height: 40px;
		line-height: 40px
	}
</style>
